<template>
  <in-viewport>
    <div class="associate-section">
      <base-layout>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <div slot="content"><people-list :people="people"/></div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'
import PeopleList from '@/containers/Team/PeopleList'

export default {
  components: {
    BaseLayout,
    BorderBox,
    PeopleList
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    people: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Team/AssociateSection.vue